<template>
    <div>
        <table-tool-bar>
            <check-tag-group v-model="active" style="display: inline-block" color="primary">
                <check-tag name="chart">
                    <common-icon :size="16" type="_zhuzhuangtu" />
                </check-tag>
                <check-tag name="list">
                    <common-icon :size="16" type="_liebiao" />
                </check-tag>
            </check-tag-group>
        </table-tool-bar>
        <div ref="mt"></div>
        <div v-if="active[0] == 'chart'" :style="{height: mtHeight + 'px'}">
            <bar-chart :orderDataSource="filter.orderDataSource" :list="chartList"></bar-chart>
        </div>
        <Table v-else :columns="columns" :data="page.list" :loading="loading" :height="mtHeight"></Table>
    </div>
</template>
<script>
import { mapCell, pipeCell } from '_c/grid/renderCell'
import { orderAnalysis } from '@/api/order-manage'
import Dict from '_u/dict'
import BarChart from '_v/order-manage/order-analysis/bar-chart-analysis'
export default {
    name: 'ListOrderAnalysis',

    components: { BarChart },

    props: {
        date: Object
    },

    data() {
        return {
            active: ['chart'],
            mtHeight: 360,
            loading: false,
            filter: {
                orderDataSource: 'R'
            },
            page: {
                list: []
            },
            chartList: [],
            dict: {
                serviceType: Dict.NULL,
                orderStatus: Dict.NULL
            },
            modal: {},
            curId: ''
        }
    },

    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    minWidth: 60
                },
                {
                    key: 'serviceType',
                    title: '服务类别',
                    align: 'center',
                    minWidth: 100,
                    render: mapCell(this.serviceTypeList)
                },
                {
                    key: 'receive',
                    title: '待接收',
                    align: 'center',
                    minWidth: 100
                },
                {
                    key: 'running',
                    title: '执行中',
                    align: 'center',
                    minWidth: 100
                },
                {
                    key: 'accept',
                    title: '待验收',
                    align: 'center',
                    minWidth: 100
                },
                {
                    key: 'archive',
                    title: '已存档',
                    align: 'center',
                    minWidth: 100
                },
                {
                    key: 'cancel',
                    title: '已取消',
                    align: 'center',
                    minWidth: 100
                },
                {
                    key: 'total',
                    title: '小计',
                    align: 'center',
                    minWidth: 100
                }
            ]
        },
        serviceTypeList() {
            return this.dict.serviceType.val()
        },
        serviceTypeKeys() {
            return this.serviceTypeList.map(el => el.id)
        }
    },

    watch: {
        date: {
            handler(val) {
                this.fetch()
            },
            deep: true
        }
    },

    created() {
        this.fetch()
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.getBoundingClientRect().top -
                40
        })
    },

    methods: {
        fetch() {
            this.loading = true
            let date = Object.assign({}, this.date)
            let body = Object.assign(date, this.filter)
            Promise.all([
                Dict.get(['service_type', 'order_status']),
                orderAnalysis(body)
            ])
                .then(args => {
                    var [dictGroup, page] = args

                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name]
                    })

                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        setPageData(data) {
            var group = data.list ? data.list.groupBy('serviceType') : {},
                list = [],
                totalRow = {
                    receive: 0,
                    running: 0,
                    accept: 0,
                    archive: 0,
                    cancel: 0,
                    total: 0
                }
            this.serviceTypeKeys.forEach(k => {
                let row = {
                    serviceType: k,
                    serviceTypeName: this.dict.serviceType.val(k)
                }
                row.receive = this.total(group[k] || [], '2')
                row.running = this.total(group[k] || [], '3')
                row.accept = this.total(group[k] || [], '6')
                row.archive = this.total(group[k] || [], '5')
                row.cancel = this.total(group[k] || [], '7')
                // 合计列
                row.total =
                    row.receive +
                    row.running +
                    row.accept +
                    row.archive +
                    row.cancel
                Object.keys(totalRow).forEach(key => {
                    // 合计行
                    totalRow[key] += row[key]
                })
                list.push(row)
            })
            totalRow.serviceType = '合计'
            // 图表专用列表
            this.chartList = JSON.parse(JSON.stringify(list))
            list.push(totalRow)
            this.page.list = list
        },
        total(obj, status) {
            var data = obj.find(v => v.orderStatus == status),
                total = data ? data.total : 0
            return parseInt(total)
        }
    }
}
</script>
<style lang="less" 
    scoped>
</style>